import type {
  BillingHoldReason,
  BillingMissingItem,
  BillingState,
  EpocusBillingStatus,
} from "$global-providers/rxdb-provider/collections/epocus-billing-status";

export const BILLING_STATE_LABELS: Record<BillingState, string> = {
  DRAFT: "Draft",
  INCOMPLETE: "Incomplete",
  READY_TO_BILL: "Ready to bill",
  NON_BILLABLE: "Non-billable",
  EXPORTED: "Exported",
};

export const BILLING_HOLD_REASON_LABELS: Record<BillingHoldReason, string> = {
  NON_DIAGNOSTIC: "Non-diagnostic (QA)",
  MAJOR_DISCREPANCY: "Major discrepancy (QA)",
};

export const BILLING_HOLD_REASON_HINTS: Record<BillingHoldReason, string> = {
  NON_DIAGNOSTIC:
    "The reviewer scored the images 1 or 2 stars. It comes back if they raise the score.",
  MAJOR_DISCREPANCY:
    "Held until the performing clinician amends the report or confirms it as it stands.",
};

export const BILLING_MISSING_ITEM_LABELS: Record<BillingMissingItem, string> = {
  PATIENT_NOT_LINKED: "Patient not linked",
  NO_DOB: "No date of birth",
  NO_MRN: "No MRN",
  NO_DOS: "No date of service",
  NO_NPI: "No NPI on the rendering provider's profile",
  NO_CODES: "No billing code",
  NO_NEEDLE_IMAGE: "No image marked needle-in-target",
};

export const incompleteBillingReasonLabels = ({
  status,
  missingItems,
}: Pick<EpocusBillingStatus, "status" | "missingItems">): string[] => [
  ...(status === "DRAFT" ? ["Not signed"] : []),
  ...missingItems.map((item) => BILLING_MISSING_ITEM_LABELS[item]),
];
